module.exports = __webpack_public_path__ + "static/assets/d634dc12eb4f75bbb9000c13317d59d2.svg";